import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import VueElementLoading from 'vue-element-loading';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'gr-report',
	components: {
		Paginate,
		DatePicker,
		download,
		JsonExcel,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			pageno: 0,
			totalRows:0,
			pageCount: 0,
			listSupplierData: [],
			listgrReportData: [],
			listWarehouseData: [],
			listReportDatacsv: [],
			csvFields: [],
			formattedDate: '',
			fromdate: '',
			todate: '',
			suppliername: '',
			poid: '',
			invoice: '',
			clientproductid: '',
			isLoading: false,
			resultCount: '',
			listClientData: [],
			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			formattedDate: '',
			user_type: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			show: false,
      download: true,
      dataFilter2: '',
			reportname: '',
			limitExeed: false,
      recordLimit: 0,
		}
	},
	computed: {},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = "grReport"
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')

		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.getClientList();
				this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
			this.getRecordLimit()
	},
	methods: {
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
      this.show = true;
      this.download = false;
			if (!this.limitExeed) {
				this.getgrReportDataForXls(3)

			}
    },
		startDownload(){
		this.isLoadingforxls =true;
		},
		finishDownload(){
		this.isLoadingforxls =false;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					// console.log(result.data.data);
					this.listWarehouseData = result.data.data;
				}, error => {
					console.error(error)
				})
		},
		clientSelected() {
			if (this.clientid != this.client) {
				this.clientid = this.client;
				if (this.clientid && this.warehouseid)
					this.getsupplierData();
				if (this.user_type != 'warehouse_user') {
					this.listWarehouseData = []
					this.getWarehouseList();
					if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
						this.warehouse = this.warehouseid = '';
					} else {
						this.warehouse = ''
					}
				} else {
					if (this.warehouseid && this.clientid);
					// this.getgrReportData();
				}
			}
			this.listgrReportData = [];
			this.pageno = this.pageCount = 0;
		},

		warehouseSelected() {
			this.warehouseid = this.warehouse;
			this.pageno = this.pageCount = 0;
			if (this.warehouseid) {
				if (this.clientid) {
					this.getsupplierData();
					// console.log(this.warehouse);
					// this.getgrReportData();
				} else {
					this.getClientList();
				}
			}
		},
		getsupplierData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				warehouseid: this.warehouseid,
				clientid: this.clientid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'supplierList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listSupplierData = result.data.data
				}, error => {
					console.error(error)
				})
		},
		//to get gr Report list
		getgrReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (csvCheck == 2){
				this.show=false;
				this.download =true;
					this.limitExeed = false;
			}
			if (this.clientid == '' || this.client == '') {
				this.ClientErr = 'Client is required';
				this.pageno = this.pageCount = 0;
				this.listgrReportData = [];
				return false;
			}

			if (this.warehouseid == '' || this.warehouse == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageno = this.pageCount = 0;
				this.listgrReportData = [];
				return false;
			}

			this.isLoading = true;
			var fr_date = '';
			var to_date = '';
			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate)
			}
			this.input = ({
				offset: this.pageno,
				limit: 10,
				fromddate: fr_date,
				todate: to_date,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				suppliercompanyname: this.suppliername,
				pono: this.poid,
				invoiceno: this.invoice,
				clientproductid: this.clientproductid,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
				  })
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'grReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.csvFields = {
							'warehouseid': 'Warehouse ID',
							'suppliercompanyname': 'Supplier Name',
							'invoiceno': 'Invoice',
							'pono': 'POID',
							'poitemid': 'PO Line ID',
							'clientproductid': 'Client Product ID',
							'productname': 'Product Name',
							'mrp': ' Product MRP',
							'hsncode': 'HSN Code',
							'hsnrate': 'HSN Rate',
							'totalreceivequantity': 'Total Received Qty',
							'checkedquantity': 'Total Accepted Qty',
							'rejectedquantity': 'Total Rejected Qty',
							'rtvreason': 'Reject Reasons',
							'createddate': 'GR datetime'
						};
						var dateFilter = ['GRdatetime'];
						var skipFilter = ['GRdatetime'];
						this.listgrReportDataCsv = result.data.data;
						csvHelper.data.jsonToCSV('grReport', this.listgrReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('grReport', this.listgrReportDataCsv, this.csvFields, dateFilter, skipFilter);

					} else {
						this.listgrReportData = result.data.data
						if (result.data.errorCode == -1) {
							this.resultCount = 0
						} else {
							this.totalRows = result.data.count
							if (Number(this.totalRows) > Number(this.recordLimit)) {
							 this.limitExeed = true
						 }
							this.resultCount = result.data.count
							if (this.totalRows < 10) {
								this.pageCount = 1
							} else {
								this.pageCount = Math.ceil(this.totalRows / 10)
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		getgrReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			var fr_date = '';
			var to_date = '';
			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate)
			}
			this.input = ({
				offset: this.pageno,
				limit: 10,
				fromddate: fr_date,
				todate: to_date,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				suppliercompanyname: this.suppliername,
				pono: this.poid,
				invoiceno: this.invoice,
				clientproductid: this.clientproductid,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'grReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls = {
									 'Warehouse ID':'warehouseid',
									 'Supplier Name':'suppliercompanyname',
									 'Invoice':'invoiceno',
									 'POID':'pono',
									 'PO Line ID':'poitemid',
									 'Client Product ID':'clientproductid',
									 'Product Name':'productname',
									 ' Product MRP':'mrp',
									 'HSN Code':'hsncode',
									 'HSN Rate':'hsnrate',
									 'Total Received Qty':'totalreceivequantity',
									 'Total Accepted Qty':'checkedquantity',
									 'Total Rejected Qty':'rejectedquantity',
									 'Reject Reasons':'rtvreason',
									 'GR datetime':'createddate'
								};

								this.listReportDataforxls = result.data.data;
							}
							else {
									if (result.data.status == true) {
										this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
									} else {
										this.$alertify.error(result.data.msg.message);
									}
								}


					}


				}, error => {
					console.error(error)
				})
		},
		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * 10
			this.getgrReportData();
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		//to reset search form
		resetSearchForm() {
			this.show=false;
      this.download =true;
			this.fromdate = '';
			this.todate = '';
			this.suppliername = '';
			this.poid = '';
			this.invoice = '';
			this.clientproductid = '';
			this.listgrReportData = [];
			this.pageno = 0;
			this.pageCount = 0;
			this.totalRows =0;
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function(event) {
			this.$validator.validateAll().then(() => {
				event.target.reset();
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/grReport/grReport.component.js